var _defs, _path, _path2, _rect, _path3, _path4, _path5, _path6, _rect2, _path7, _path8, _rect3, _path9, _path0, _path1, _path10, _path11, _path12, _path13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconsMsEventLogWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 27.32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:none;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M13,6c-.55,0-1-.45-1-1v-1h-6v1c0,.55-.45,1-1,1s-1-.45-1-1v-1h-1c-.55,0-1,.45-1,1v3h14v-3c0-.55-.45-1-1-1h-1v1c0,.55-.45,1-1,1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,9v8c0,1.65,1.35,3,3,3h5.5c.55,0,1-.45,1-1s-.45-1-1-1H3c-.55,0-1-.45-1-1v-7h-1c-.55,0-1-.45-1-1Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 6,
    y: 2,
    width: 6,
    height: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15,2h-1v2h1c.55,0,1,.45,1,1v3h1c.55,0,1,.45,1,1v-4c0-1.65-1.35-3-3-3Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1,8h1v-3c0-.55.45-1,1-1h1v-2h-1c-1.65,0-3,1.35-3,3v4c0-.55.45-1,1-1Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12,5c0,.55.45,1,1,1s1-.45,1-1v-1h-2v1Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14,1c0-.55-.45-1-1-1s-1,.45-1,1v1h2v-1Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 12,
    y: 2,
    width: 2,
    height: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5,6c.55,0,1-.45,1-1v-1h-2v1c0,.55.45,1,1,1Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6,1c0-.55-.45-1-1-1s-1,.45-1,1v1h2v-1Z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 4,
    y: 2,
    width: 2,
    height: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16,8H2v2h14.15c-.09-.15-.15-.31-.15-.5v-1.5Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17,8h-1v1.5c0,.19.06.35.15.5h.85c.55,0,1-.45,1-1s-.45-1-1-1Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1,8c-.55,0-1,.45-1,1s.45,1,1,1h1v-2h-1Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15,20c-2.21,0-4-1.79-4-4s1.79-4,4-4,4,1.79,4,4-1.79,4-4,4ZM15,14c-1.1,0-2,.9-2,2s.9,2,2,2,2-.9,2-2-.9-2-2-2Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19,21c-.26,0-.51-.1-.71-.29l-1.8-1.8c-.39-.39-.39-1.02,0-1.41s1.02-.39,1.41,0l1.8,1.8c.39.39.39,1.02,0,1.41-.2.2-.45.29-.71.29Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.89,27.09s0,.05-.02.07-.04.04-.08.05c-.04.01-.09.02-.15.03s-.14.01-.24.01-.17,0-.23-.01-.11-.02-.15-.03-.06-.03-.08-.05c-.02-.02-.02-.04-.02-.07v-4.09h0l-1.46,4.08s-.03.06-.05.08-.05.04-.1.05c-.04.01-.09.02-.15.03s-.14,0-.22,0-.16,0-.22,0-.11-.02-.15-.03c-.04-.01-.07-.03-.1-.05-.02-.02-.04-.05-.05-.07l-1.41-4.08h0v4.09s0,.05-.02.07c-.01.02-.04.04-.08.05-.04.01-.09.02-.15.03-.06,0-.14.01-.24.01s-.17,0-.23-.01-.11-.02-.15-.03-.06-.03-.08-.05c-.01-.02-.02-.04-.02-.07v-4.48c0-.13.03-.23.11-.3.07-.07.16-.11.28-.11h.67c.12,0,.22,0,.31.03.08.02.16.05.22.1.06.05.11.11.16.18s.08.16.11.27l1.09,2.99h.02l1.12-2.99c.03-.11.07-.2.11-.28.04-.08.09-.14.14-.18.05-.05.12-.08.19-.1.07-.02.16-.03.25-.03h.69c.07,0,.13,0,.18.03.05.02.09.05.12.08.03.03.06.08.07.13.02.05.03.11.03.17v4.48h0,0Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.96,25.73c0,.26-.05.5-.15.69-.1.2-.23.37-.4.5-.17.13-.37.23-.59.3-.22.07-.47.1-.72.1-.17,0-.33-.01-.48-.04-.15-.03-.28-.06-.39-.1s-.21-.08-.29-.13-.13-.08-.16-.12c-.03-.03-.06-.08-.07-.14s-.02-.16-.02-.27c0-.08,0-.15,0-.2,0-.05.01-.1.03-.13.01-.03.03-.06.05-.07.02-.01.04-.02.07-.02.04,0,.09.02.15.06.07.04.15.09.25.14.1.05.23.1.37.14.14.04.31.06.5.06.12,0,.24-.02.33-.05.1-.03.18-.07.25-.13.07-.05.12-.12.16-.2s.05-.17.05-.27c0-.11-.03-.21-.09-.29-.06-.08-.14-.15-.24-.22-.1-.06-.21-.12-.34-.18s-.26-.11-.39-.18c-.13-.06-.27-.13-.39-.21s-.24-.17-.34-.28-.18-.24-.24-.39-.09-.33-.09-.54c0-.24.05-.45.13-.64.09-.18.21-.33.36-.45.15-.12.33-.21.54-.27.21-.06.42-.09.65-.09.12,0,.24,0,.36.03.12.02.23.04.33.07.1.03.19.07.28.11.08.04.13.07.16.1.03.03.04.05.05.07,0,.02.02.04.02.07,0,.03.01.07.01.11,0,.05,0,.1,0,.17,0,.08,0,.14,0,.19,0,.05,0,.1-.02.13,0,.03-.02.06-.04.07s-.04.02-.07.02-.07-.02-.14-.05-.14-.08-.23-.12c-.09-.04-.19-.08-.31-.12-.12-.03-.25-.05-.39-.05-.11,0-.21.01-.29.04s-.15.06-.21.11-.1.11-.12.17c-.03.07-.04.14-.04.21,0,.11.03.21.09.29s.14.15.24.22.22.12.35.18.26.11.4.18c.13.06.27.13.4.21.13.08.24.17.35.28s.18.24.24.39.09.32.09.53h0s0,0,0,0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsMsEventLogWhite);
export default __webpack_public_path__ + "static/media/Icons_MS_Event_Log_White.6569f2089731a396790700cd10ad1480.svg";
export { ForwardRef as ReactComponent };